import Vue from 'vue'
import Vuex from 'vuex'
import rootState from '../index'

Vue.use(Vuex)

export default {
  namespaced: true,
  rootState,
  state: {
    // years, rates, ratesDate
    initData: {},
    companys: [],
    // calculation
    calcFilter: {
      btn: ['system', 'date', 'count', 'price', 'infor', 'diff'],
      select: 'date',
      asc: true,
      all: false,
    },
    // payments
    payments: {
      open: [],
      close: [],
    },
  },
  getters: {
    initData: (state) => state.initData,
    companys: (state) => state.companys,
    calcFilter: (state) => state.calcFilter,
    // payments
    payments: (state) => state.payments,
  },
  mutations: {
    setInitData(state, values) {
      values.years = values.years.map((d) => parseInt(d.JAHR))
      // add next year
      values.years.unshift(values.years[0] + 1)
      state.initData = values
    },
    setCompanys(state, values) {
      state.companys = values
    },
    // calculation
    setCalcFilter(state, value) {
      state.calcFilter = value
    },
    // payments
    setPayments(state, value) {
      state.payments = value
    },
  },
  actions: {
    async loadInitData({ dispatch }) {
      await Promise.all([dispatch('getInitData'), dispatch('getCompanys')])
    },
    getInitData({ commit }) {
      return Vue.prototype.$axios.get('plan/init').then((res) => {
        commit('setInitData', res.data)
      })
    },
    getCompanys({ commit }) {
      return Vue.prototype.$axios.get('plan/companys').then((res) => {
        commit('setCompanys', res.data)
      })
    },
    setInvoicePaid({ commit, state, rootState }, data) {
      let id = data.id
      let tmpItem = state.payments.open.find((item) => item.id == id)

      tmpItem.payUser = rootState.user.id
      if (data.ctrlKey) {
        Vue.prototype.$axios
          .put('plan/payments/paid/' + id + '/' + tmpItem.payUser)
          .then(() => {
            // add paid
            tmpItem.paid = 1
            tmpItem.payDate = Vue.prototype.moment().format('Y-MM-DD HH:mm:ss')
            state.payments.close.push(tmpItem)
            // delete unpaid
            state.payments.open = state.payments.open.filter((i) => i.id != id)
          })
      } else {
        commit(
          'setToastMsg',
          {
            title: 'INFO',
            msg: ['Für Zahlungseingang muss die "Strg" Taste gedrückt werden.'],
            color: 'info',
          },
          { root: true }
        )
      }
    },
  },
  modules: {},
}
